<div class="grid-wrapper">
    <div class="k-i-loading" *ngIf="isLoading | async"></div>
</div>